import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	project: {
		id: 'quick-find.filters.names.project',
		defaultMessage: 'Project',
		description: 'Label for filtering by project',
	},
	jiraFilterProjectPlaceholder: {
		id: 'quick-find.jira.filter.project.placeholder',
		defaultMessage: 'Find projects',
		description: 'Placeholder for project filter search input',
	},
	jiraFilterProjectLabelSelected: {
		id: 'quick-find.jira.filter.project.selected',
		defaultMessage: 'Selected',
		description: 'Jira project filter selected label',
	},
	jiraFilterProjectLabelUnselected: {
		id: 'quick-find.jira.filter.project.unselected',
		defaultMessage: 'Suggested',
		description: 'Jira project filter unselected label',
	},
	projectGalaxia: {
		id: 'quick-find.filters.names.project-galaxia',
		defaultMessage: 'Space',
		description: 'Label for filtering by project',
	},
	jiraFilterProjectPlaceholderGalaxia: {
		id: 'quick-find.jira.filter.project.placeholder-galaxia',
		defaultMessage: 'Find spaces',
		description: 'Placeholder for project filter search input',
	},
});
